import { updateObject } from 'utils/updateObject'
import { List } from 'immutable'
import { ADD, REMOVE } from 'modules/Notifications/types'

const initialState = {
  notifications: [],
}

const addNotification = (state, { payload }) => {
  const updatedNotifications = List(state.notifications).push(payload)
  return updateObject(state, { notifications: updatedNotifications.toJS() })
}

const removeNotification = (state, { payload }) => {
  const current = List(state.notifications)
  const index = current.findIndex(({ UUID }) => UUID === payload.UUID)

  if (index === -1) {
    return state
  }

  return updateObject(state, { notifications: current.remove(index).toJS() })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return addNotification(state, action)
    case REMOVE:
      return removeNotification(state, action)
    default:
      return state
  }
}

export default reducer
